import { Fragment, type ReactElement } from 'react'

import type { Stanza } from '@maria-cavalheiro-website/shared-types'

export interface StanzaLinesProps {
  readonly stanza: Stanza
}

/**
 * The verses of one stanza, separated by `<br>`.
 *
 * EXTRACTED IN PHASE 0019 BECAUSE A SECOND READER APPEARED. The poem route and the
 * fullscreen ebook both render the same stanza the same way, and a verse break is
 * not a detail either of them should be free to get differently right: `<br>`
 * inside one `<p>` is what makes a stanza announce as a stanza, where the design's
 * nested `<span>`s said nothing at all about where one begins.
 *
 * A FRAGMENT, NOT A `<p>`. The paragraph belongs to the caller, because the two
 * callers put different classes on it and the poem route puts it inside a flex
 * leaf. What is shared is the line breaking, and only that.
 *
 * The key pairs the line with its index rather than using either alone: a refrain
 * repeats lines verbatim within a stanza, so the text is not unique, and the index
 * alone would be a lint error dressed as an identifier. The stanzas are frozen,
 * authored content that is never reordered or filtered, so the pair is stable.
 */
export function StanzaLines({ stanza }: StanzaLinesProps): ReactElement {
  return (
    <>
      {stanza.map((line, index) => (
        <Fragment key={`${line}-${String(index)}`}>
          {index > 0 ? <br /> : null}
          {line}
        </Fragment>
      ))}
    </>
  )
}
